import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { Backend } from '@k2/common/backend/backend';
import { Partner } from '@k2/common/entities-state/types';
import { PartnerAutocompleteOptionComponent } from '@k2/common/partners/component/partner-autocomplete-option/partner-autocomplete-option.component';
import { PartnerIngotComponent } from '@k2/common/partners/component/partner-ingot/partner-ingot.component';
import { ComponentSpec } from '@k2/common/ui/component-spec';
import { AutocompleteSelectorConfig } from '@k2/common/ui/components/autocomplete-selector/autocomplete-selector.component';
import {EntityFile, PartnerAvatarFile} from "@k2/common/file-jet/entity-file";

@Component({
    selector: 'partner-avatar',
    templateUrl: 'partner-avatar.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PartnerAvatarComponent implements OnChanges {
  @Input() partner: Partner;
  @Input() width: number;
  @Input() height: number;
  @Input() alt: string;

  constructor(private backend: Backend) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.config == null) return;
  }

  get entityFile(): EntityFile | null {
    if (this.partner.avatar_workspace) {
      return new PartnerAvatarFile(String(this.partner.id));
    }
    return null;
  };
}
